import script from "./ViewAGroupTalk.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAGroupTalk.vue?vue&type=script&setup=true&lang=js"

import "./ViewAGroupTalk.vue?vue&type=style&index=0&id=4930eeaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4930eeaa"]])

export default __exports__